import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import ChangePasswordView from 'views/agent/configuration/changePassword/changePasswordView'; // Importing ChangePasswordView component

/**
 * Class representing the change password agent list view.
 * @extends JetView
 */
export default class changePasswordAgentListView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Retrieves the current theme from app configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applies the current theme to the toolbar
                    elements: [
                        {
                            view: 'label', // Label component for displaying text
                            label: _('Cambiar Contraseña'), // Translated label text
                            width: 300, // Sets the width of the label
                        },
                    ],
                },
                ChangePasswordView, // Includes the ChangePasswordView component
            ],
        };
        webix.ui.fullScreen(); // Sets the UI to full screen mode
        return {
            type: 'wide', // Sets the type of layout to 'wide'
            cols: [left], // Defines the columns layout with the left configuration
        };
    }
}

// FILE DOCUMENTED
